import React from 'react';
import { Container, Modal, Row, Col } from 'react-bootstrap';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const CitizenServicesModal = ({ show, handleClose }) => {
    const citizenBodyRefCitizen = useRef(null);
    const citizenModalInfoRefCitizen = useRef(null);
    const navigate = useNavigate()

    return (
        <Modal show={show} onHide={handleClose} className='citizen-modal'>
            <div className='citizenmodal-info' ref={citizenModalInfoRefCitizen}>
                {/* <img src="images/citizen-bg.png" alt="Logo" className='w-100' /> */}
                <div className='citizen-body' ref={citizenBodyRefCitizen}>
                    <Modal.Header closeButton className='mx-5 px-0'>
                        <Modal.Title> <a className="navbar-brand d-flex align-items-center" href="#">
                            <img src="images/logo.svg" className='logo'
                                alt="Logo" />
                            <div className="brand-text ms-2">
                                <img src="images/logo-text.svg"
                                    className='logo-text' alt="Logo Text" />
                            </div>
                        </a></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            className='modalbody-head d-sm-block d-md-flex justify-content-between align-items-center mx-md-5 mx-sm-0'>
                            <div
                                className='stat-head ms-5 d-flex'>
                                <h4>Citizen<br /><span>Services</span></h4>
                            </div>
                            <InputGroup className="input-search mb-3" style={{ maxWidth: '400px', alignItems: 'center', display: 'flex', backgroundColor: 'white', height: '50px', borderRadius: '30px' }}>

                                <Form.Control placeholder="Search Service" aria-label="Search Service" style={{ borderRadius: '50px', padding: '10px 20px', border: '0px', background: 'transparent' }} />
                                <InputGroup.Text style={{ background: 'transparent', border: 'none', paddingLeft: '15px' }}>
                                    <BsSearch color="#b3b3b3" className='search' />
                                </InputGroup.Text>
                            </InputGroup>
                        </div>

                        <Container><Row>
                            <Col xxl={4} xl={4} md={12} lg={6} xs={12} sm={12}>
                                <span className='tax-head3'>Property </span>

                                <ul className='tax-ul ps-0 ps-2 pe-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/SelfAssessmentForm") }}>Apply For New Assessment</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/SelfAssessmentForm")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/SelfAssessmentForm");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For New Assessment
                                    </li>
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/AditionAlterition") }}>Addition/ Alteration</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/AditionAlterition")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/AditionAlterition");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Addition/ Alteration
                                    </li>
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Mutation (Transfer of Ownership)</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/HouseTaxMutationApplication")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/HouseTaxMutationApplication");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Mutation Owner Details(Transfer of Ownership)
                                    </li>
                                    {/* <li className='pb-2 pt-2'>Conversion from Property Tax to Land Tax (VLT)</li> */}

                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Demolition (Conversion from Property Tax to Land Tax (VLT))</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/UnderConstruction")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/UnderConstruction");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Demolition (Conversion from Property Tax to Land Tax (VLT))
                                    </li>
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Tax Exemption</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/TaxException")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/TaxException");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For House Tax Exemption
                                    </li>

                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Vacancy Remission</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/UnderConstruction")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/UnderConstruction");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Vacancy Remission
                                    </li>
                               <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/PropertyValuation")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/PropertyValuation");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Property Valuation Certificate
                                    </li>
                                    {/* <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/PropertyValuation")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/PropertyValuation");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Property Valuation Certificate
                                    </li> */}
                                    <li className='pb-0 pt-0'></li>
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/V2HouseTaxAutoCalculation") }}>House/Property Tax Auto Calculation</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/V2HouseTaxAutoCalculation")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/V2HouseTaxAutoCalculation");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For House/Property Tax Auto Calculation
                                    </li>

                                </ul>
                                <span className='tax-head3'>Private Tap</span>

                                <ul className='tax-ul tax-ul2 ps-0 ps-2 pe-2'>
                                   <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/UnderConstruction")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/UnderConstruction");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For New Connection
                                    </li>
                                    {/* <li
                                        className='pb-2'
                                        onClick={() => navigate("/WaterTapNewConection")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/WaterTapNewConection");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For New Connection
                                    </li> */}
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Apply For Closure Of Connection</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/UnderConstruction")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/UnderConstruction");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Closure Of Connection
                                    </li>
                                </ul>

                                <p className='taxhead-sub ps-2 pt-1'>Trade License</p>
                                <ul className='tax-ul tax-ul2 ps-0 ps-2 pe-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/UnderConstruction") }}>Apply For New License</li> */}
                          <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/UnderConstruction")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/UnderConstruction");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For New License
                                    </li>
                                    {/* <li
                                        className='pb-2'
                                        onClick={() => navigate("/NewTradeLicence")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/NewTradeLicence");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For New License
                                    </li> */}
                                    {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Apply For Closure Of License</li> */}
                                    <li
                                        className='pb-2 pt-2'
                                        onClick={() => navigate("/TradeLicenseClosure")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/TradeLicenseClosure");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Closure Of Trade License
                                    </li>
                                </ul>

                            </Col>
                            <Col xxl={4} xl={4} md={12} lg={6} xs={12} sm={12}>
                                <span className='tax-head4'>Miscellaneous</span>
                                <p className='taxhead-sub ps-2 pt-1'>Certificates</p>
                                <ul className='tax-ul tax-ul1 ps-0 ps-2'>
                                    <li className='pb-2 pt-2'>
                                        <a href="https://dc.crsorgi.gov.in/crs/" className="text-decoration-none">Apply For Birth & Death Certificate</a>
                                    </li>
                                    <li className='pb-2 pt-2'>
                                        <a href="https://vswsonline.ap.gov.in/#/home" className="text-decoration-none">Apply For Marriage Certificate </a>
                                    </li>

                                </ul>





                                <span className='tax-head'>Others</span>

                                <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/GramPanchyatSwagage") }}>Sewerage Charges</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/GramPanchyatSwagage")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/GramPanchyatSwagage");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Sewerage Charges
                                    </li>

                                </ul>
                                <span className='tax-head4'>Water Supply</span>

                                <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/PlannedSupplyReport") }}>Planned Outages</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/PlannedSupplyReport")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/PlannedSupplyReport");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Check for Planned Outages
                                    </li>

                                </ul>
                                <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/RawWaterQualityReport") }}>RAW Water Quality Report</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/RawWaterQualityReport")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/RawWaterQualityReport");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Check for RAW Water Quality Report
                                    </li>
                                </ul>

                                <span className='tax-head4'>Revenue Status</span>

                                <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                    {/* <li className='pb-2' onClick={(e) => { navigate("/PlannedSupplyReport") }}>Planned Outages</li> */}
                                    <li
                                        className='pb-2'
                                        onClick={() => navigate("/CitizenRevenueNotice")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                navigate("/CitizenRevenueNotice");
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Know Your Grama Panchayat Revenue Status
                                    </li>

                                </ul>


                                {/* <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                        <li className='pb-2' onClick={(e) => { navigate("/PlannedSupplyReport") }}> Water Supply Planned Outages Report</li>
                                    </ul> */}

                                {/* <p className='taxhead-sub ps-2 pt-1'>Miscellaneous / Sale of GP Produces</p>
                                    <ul className='tax-ul tax-ul7 ps-0 ps-2'>
                                        <li className='pb-2'>Sale Of Compost</li>
                                        <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Office News Paper Sales</li>
                                        <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Scraps Sales Payment</li>
                                        <li className='pb-2 pt-2' onClick={(e) => { navigate("/UnderConstruction") }}>Sale Of Gravel from GP Assets Payment</li>
                                    </ul> */}
                            </Col>

                            <Col xxl={4} xl={4} md={12} lg={6} xs={12} sm={12}>

                                                                <span className='tax-head4'>Building Permission</span>

                                <ul className='tax-ul tax-ul5 ps-0 ps-2'>
                                    <li
                                        className='pb-2'
                                        onClick={() =>
                                            window.open(
                                                "https://portal.apdpms.ap.gov.in/permits",
                                                "_blank",
                                                "noopener,noreferrer"
                                            )
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                window.open(
                                                    "https://portal.apdpms.ap.gov.in/permits",
                                                    "_blank",
                                                    "noopener,noreferrer"
                                                );
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        Apply For Building Permission
                                    </li>
                                </ul>


                            </Col>

                        </Row>
                        </Container>
                    </Modal.Body>
                </div>
            </div>

        </Modal>
    );
};

export default CitizenServicesModal;